import urls from 'urls';

export const useEmailPreview = ({eventId}) => {
  const sendEmailPreview = async () => {
    const errorDefault =
      'Unknown error while attempting to send your email preview. Please check the email address and try again.';

    window.dataLayer.push({
      event: 'checkOutLinks',
      checkOutLinkClicked: 'email preview',
    });

    try {
      const url = urls.get('ajax_email_preview', {
        event_id: eventId,
      });

      const response = await evite.fetch(url, {
        method: 'post',
        credentials: 'include',
        cache: 'no-cache',
        headers: {
          'X-CSRFToken': evite.cookie('csrftoken'),
          Accept: 'application/json',
        },
      });
      const data = await response.json();

      if (response.ok) {
        alert(
          'Success! Your email preview has been sent to the primary email address on this account.'
        );
      } else {
        const error = data.message || errorDefault;
        console.log(error);
      }
    } catch (e) {
      evite.error('Failed to update', e);
    }
  };

  return {sendEmailPreview};
};
